export const DEFAULT_DEBOUNCE_MS = 100;
export const MIN_CHARS_FOR_SCAN = 3;
